// extracted by mini-css-extract-plugin
module.exports = {"btnBan":"btnBan_btnBan__1RYtP"};